(()=>{
  document.querySelectorAll('[data-axion-configurator][data-product-handle="axion-designer-ps5"]').forEach(root=>{
    if(root.dataset.axionRearSmoothV4==='1')return;
    root.dataset.axionRearSmoothV4='1';

    const viewer=root.querySelector('[data-axion-model-viewer]');
    if(!viewer)return;

    const mat=name=>viewer.model?.materials?.find(m=>m.name===name);

    const applyRearSmooth=()=>{
      try{
        const rear=mat('AXION_SHELL__VRayMtl55');
        if(!rear)return;
        const pbr=rear.pbrMetallicRoughness;
        pbr?.setMetallicFactor?.(0.06);
        pbr?.setRoughnessFactor?.(0.34);
        if(rear.normalTexture?.setTexture){
          const result=rear.normalTexture.setTexture(null);
          result?.catch?.(err=>console.warn('[AXION rear smooth normal]',err));
        }
        root.dataset.axionRearSmooth='1';
      }catch(err){
        console.warn('[AXION rear smooth]',err);
      }
    };

    // Il PS è gestito esclusivamente dal loader 3D, che conserva la scelta
    // personalizzata anche quando il pannello Estetica non è più nel DOM.
    // Evitiamo qui una seconda scrittura dei materiali: causava il flash nero
    // e il ritorno OEM quando si cambiava step o colore della scocca.
    viewer.addEventListener('load',()=>requestAnimationFrame(applyRearSmooth));
    if(viewer.model)requestAnimationFrame(applyRearSmooth);
  });
})();
